import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { API_URL } from '@core/config/api-url.token';
import { API_ENDPOINTS } from '@shared/constants/api-endpoints.const';
import { Observable } from 'rxjs';
import { PatientDocumentDto } from '../../dtos/patient-document.dto';

@Injectable()
export class PatientDocumentsRemoteDatasource {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = inject(API_URL);

  public list(organizationId: number, patientId: string): Observable<readonly PatientDocumentDto[]> {
    return this.http.get<readonly PatientDocumentDto[]>(
      `${this.apiUrl}${API_ENDPOINTS.documents.forPatient(organizationId, patientId)}`,
    );
  }

  public upload(organizationId: number, patientId: string, file: File): Observable<PatientDocumentDto> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<PatientDocumentDto>(
      `${this.apiUrl}${API_ENDPOINTS.documents.forPatient(organizationId, patientId)}`,
      formData,
    );
  }

  // `GET .../documents/{documentId}/download` proxy-streams the raw bytes (no JSON envelope),
  // hence `responseType: 'blob'` -- same shape as `ClientsRemoteDatasource.getInvoicePdf`.
  public download(organizationId: number, documentId: number): Observable<Blob> {
    return this.http.get(
      `${this.apiUrl}${API_ENDPOINTS.documents.download(organizationId, documentId)}`,
      { responseType: 'blob' },
    );
  }

  public remove(organizationId: number, documentId: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}${API_ENDPOINTS.documents.byId(organizationId, documentId)}`);
  }
}
